import React from 'react';
import Icon, { Props } from './icon';

export const ClockNineInfo: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 40 40">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6517 10.3167C21.3973 10.3167 22.0017 10.9211 22.0017 11.6667V20.6517C22.0017 21.3973 21.3973 22.0017 20.6517 22.0017H13.3333C12.5877 22.0017 11.9833 21.3973 11.9833 20.6517C11.9833 19.9061 12.5877 19.3017 13.3333 19.3017H19.3017V11.6667C19.3017 10.9211 19.9061 10.3167 20.6517 10.3167Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5833 23.85C26.4169 23.85 23.85 26.4169 23.85 29.5833C23.85 32.7498 26.4169 35.3167 29.5833 35.3167C32.7498 35.3167 35.3167 32.7498 35.3167 29.5833C35.3167 26.4169 32.7498 23.85 29.5833 23.85ZM21.15 29.5833C21.15 24.9257 24.9257 21.15 29.5833 21.15C34.241 21.15 38.0167 24.9257 38.0167 29.5833C38.0167 34.241 34.241 38.0167 29.5833 38.0167C24.9257 38.0167 21.15 34.241 21.15 29.5833Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.567 28.9834C30.3126 28.9834 30.917 29.5878 30.917 30.3334V32.4167C30.917 33.1623 30.3126 33.7667 29.567 33.7667C28.8214 33.7667 28.217 33.1623 28.217 32.4167V30.3334C28.217 29.5878 28.8214 28.9834 29.567 28.9834Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3917 3.66138C27.9445 3.34421 35.2942 9.67766 36.244 18.1836C36.3267 18.9246 35.7931 19.5923 35.0521 19.6751C34.3111 19.7578 33.6434 19.2242 33.5606 18.4832C32.7678 11.3821 26.6319 6.09474 19.4917 6.35953C12.3514 6.62432 6.62413 12.3516 6.35939 19.4919C6.09465 26.6322 11.3821 32.768 18.4831 33.5607C19.2241 33.6435 19.7577 34.3112 19.675 35.0522C19.5922 35.7932 18.9245 36.3268 18.1835 36.2441C9.67768 35.2944 3.34413 27.9448 3.66124 19.3919C3.97836 10.839 10.8388 3.97856 19.3917 3.66138Z"
      />
      <path d="M31.02 26.715C31.02 27.5075 30.3775 28.15 29.585 28.15C28.7925 28.15 28.15 27.5075 28.15 26.715C28.15 25.9225 28.7925 25.28 29.585 25.28C30.3775 25.28 31.02 25.9225 31.02 26.715Z" />
    </Icon>
  );
};

export default React.memo(ClockNineInfo);
